export const SCOOPUP_ICON_SRC = "/scoopup.png";
export const SCOOPUP_ICON_CLASS = "h-5 w-5 object-contain flex-shrink-0 mt-0.5";

export const SCOOPUP_PUPPY_PASS_FEE_CLASS = "scoopup_puppy_pass_fee";

const SCOOPUP_SUBTITLES = {
  scoopup_puppy_pass_fee: "Puppy Pass",
};

export function normalizeScoopUpClassification(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_")
    .replace(/_+/g, "_");
}

export function isScoopUpClassification(value) {
  return normalizeScoopUpClassification(value).startsWith("scoopup_");
}

export function getScoopUpDisplay(value) {
  const cls = normalizeScoopUpClassification(value);
  if (!cls.startsWith("scoopup_")) return null;

  const subtitle =
    SCOOPUP_SUBTITLES[cls] ||
    cls
      .replace(/^scoopup_/, "")
      .split("_")
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ") ||
    "Interaction";

  return {
    title: "ScoopUp",
    subtitle,
  };
}
